import { ItemBar } from "components/ItemBar";
import { ToastContext } from "context/ToastContext";
import { Button } from "primereact/button";
import { useContext } from "react";
import { useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useUpdatePackageRulesetMutation } from "store/queries/packageRuleset";

import { mapPackagesFormToRequestBody } from "../helpers/mapFormToRequestBody";

export function SubmitEditPackages({ id }: { id: string }) {
  const {
    getValues,
    formState: { isValid },
  } = useFormContext();
  const navigate = useNavigate();
  const [updatePackageRuleset] = useUpdatePackageRulesetMutation();

  const { current: toastElement } = useContext(ToastContext);

  const updatePayerRule = async () => {
    const requestBody = mapPackagesFormToRequestBody(getValues());
    try {
      updatePackageRuleset({ ...requestBody, id })
        .unwrap()
        .then(() => {
          toastElement?.show({
            severity: "success",
            summary: "Package Rule updated",
            detail: "Package Rule updated successfully",
          });

          navigate("/payer-rules?tab=2");
        })
        .catch((error) => {
          if (error.status === 409) {
            toastElement?.show({
              severity: "error",
              summary: "Error",
              detail:
                "A package ruleset with this provider and payer already exists",
            });
          } else {
            toastElement?.show({
              severity: "error",
              summary: "Error",
              detail:
                "An error has occurred attempting to update the package ruleset",
            });
          }
        });
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <ItemBar>
      <div
        data-testid="submit__Hospital"
        className="flex flex-1 justify-content-end"
      >
        <Button
          label="Update Package Rule"
          onClick={updatePayerRule}
          disabled={!isValid}
        />
      </div>
    </ItemBar>
  );
}
